const bomSupportingDocumentsPath = '/bom-supporting/documents';
const bomTypeGroupPath = '/bom-type-group';
const bomTypeV2Path = '/v2/bom-types';
const bomTypeGroupV2Path = '/v2/bom-type-groups';
const bomLibraryV2Path = '/v2/bom-libraries';
const bomLibraryGroupV2Path = '/v2/bom-library-groups';
const categoryV2Path = '/v2/categories';
const subBomCustomAttributeV2Path = '/v2/sub-bom-custom-attributes';
const bomLibraryComponentV2Path = '/v2/bom-library-components';
const bomTypeGroupSlashPath = '/bom-type-group/';
const libraryBomTagsPath = '/library-bom-tags';
const mastersBomSubTypePath = '/masters/bom-sub-type';
const bomLibraryGroupPath = '/bom-library-group';
const mastersSeasonsPath = '/masters/seasons';
const colourWaysPath = '/colour-ways';
const mastersUnitsPath = '/masters/units';
const orderTestingPath = '/order-testing';
const mastersMaterialCompositionPath = '/masters/material-composition-component';
const productBomPath = '/product-bom';
const userGroupsPath = '/user-groups';
const orderSupplierPath = '/order/supplier';
const developmentOrdersPath = '/development-orders';
const bomDueDatePath = '/bom-due-date';
const developmentOrdersMarkCompletePath = '/development-orders/mark-complete';
const orderPreviousStylesPath = '/order/previous-styles';
const gradingsImportXlsPath = '/gradings/import-xls';
const ordersPermissonSamplePath = '/orders/permisson/sample';
const ordersSamplesPath = '/orders-samples';
const pointOfMeasuresPath = '/point-of-measures/';
const mastersFetchCategoriesPath = '/masters/fetch-categories';

export const API = {
  SUPPORTING_DOCUMENTS: {
    GET: bomSupportingDocumentsPath,
    POST: '/bom-supporting/upload',
    PUT: bomSupportingDocumentsPath,
    DELETE: bomSupportingDocumentsPath,
    ADD_COLOUR_LIB: '/product-bom/colour-document',
    MERGED_DOCS: '/merged-pdfs',
    POST_LINKS: '/bom-supporting/upload/links',
    REMOVE_ALL: '/remove-all-unsaved-documents',
    MULTIPART_BASE: '/bom-supporting-doc',
    SAVE_FROM_S3: '/bom-supporting-doc/documents/from-s3',
    PENDING_UPLOADS_ALL: '/bom-supporting-doc/pending-uploads',
    PENDING_UPLOADS_SCOPE: '/bom-supporting-doc/scope/pending-uploads',
  },
  BOM_TYPE: {
    CREATE: '/bom-type',
    GET: '/bom-type',
    GET_BY_ID: '/bom-type/',
    GET_ALL_BOM: '/bom-libraries',
    UPDATE: '/bom-type/',
    GET_PRDUCT_ASSOC: '/masters/supplier-type',
    DELETE: '/bom-type',
    CLEAR_HIGHLIGHT: '/product-bom/clear-highlight',
    UPDATE_SEQUENCE: '/bom-type-sequence-update',
  },
  BOM_TYPE_GROUP: {
    GET: bomTypeGroupPath,
    CREATE: bomTypeGroupPath,
    GET_BY_ID: bomTypeGroupSlashPath,
    UPDATE: bomTypeGroupSlashPath,
    DELETE: bomTypeGroupPath,
    ADD_TO_GROUP: bomTypeGroupSlashPath,
  },
  SUB_BOM_CUSTOM_ATTRIBUTE_V2: {
    LIST: subBomCustomAttributeV2Path,
    SAVE: subBomCustomAttributeV2Path,
    SEQUENCE: `${subBomCustomAttributeV2Path}/sequence`,
    DETAIL: `${subBomCustomAttributeV2Path}/`,
  },
  BOM_TYPE_V2: {
    LIST: bomTypeV2Path,
    CREATE: bomTypeV2Path,
    DELETE: bomTypeV2Path,
    DETAIL: `${bomTypeV2Path}/`,
    UPDATE: `${bomTypeV2Path}/`,
    SEQUENCE: `${bomTypeV2Path}/sequence`,
  },
  BOM_TYPE_GROUP_V2: {
    LIST: bomTypeGroupV2Path,
    CREATE: bomTypeGroupV2Path,
    DELETE: bomTypeGroupV2Path,
    DETAIL: `${bomTypeGroupV2Path}/`,
    UPDATE: `${bomTypeGroupV2Path}/`,
    ADD_BOM_TYPES: `${bomTypeGroupV2Path}/bom-types`,
  },
  BOM_LIBRARY_V2: {
    LIST: bomLibraryV2Path,
    BY_IDS: `${bomLibraryV2Path}/by-ids`,
    TAGS: `${bomLibraryV2Path}/tags`,
    UPDATE_TAGS: bomLibraryV2Path,
    FILTER_OPTIONS: `${bomLibraryV2Path}/filter-options`,
    DETAIL: `${bomLibraryV2Path}/`,
  },
  BOM_LIBRARY_GROUP_V2: {
    LIST: bomLibraryGroupV2Path,
    CREATE: bomLibraryGroupV2Path,
    DELETE: bomLibraryGroupV2Path,
    DETAIL: `${bomLibraryGroupV2Path}/`,
    UPDATE: `${bomLibraryGroupV2Path}/`,
    OPTIONS: `${bomLibraryGroupV2Path}/options`,
    ADD_BOM_LIBRARIES: `${bomLibraryGroupV2Path}/bom-libraries`,
  },
  CATEGORY_V2: {
    LIST: categoryV2Path,
  },
  BOM_LIBRARY_COMPONENT_V2: {
    BASE: bomLibraryComponentV2Path,
    DETAIL: `${bomLibraryComponentV2Path}/`,
    UPLOADS: `${bomLibraryComponentV2Path}/document-uploads`,
    WORKBOOKS: `${bomLibraryComponentV2Path}/workbooks`,
    IMPORTS: `${bomLibraryComponentV2Path}/imports`,
  },
  BOM_MASTERS_V2: {
    DETAIL: '/v2/bom-masters/',
  },
  PRODUCT_BOM_V2: {
    ORDERS: '/v2/development-orders/',
  },
  BOM_LIBRARY: {
    GET: bomTypeGroupPath,
    GET_LIBRARY: '/bom-library',
    GET_LIBRARY_NAME: '/bom-library-names',
    GET_LIBRARY_BY_ID: '/bom-library/',
    CREATE: bomTypeGroupPath,
    GET_BY_ID: bomTypeGroupSlashPath,
    UPDATE: bomTypeGroupSlashPath,
    DELETE: bomTypeGroupPath,
    ADD_TO_GROUP: bomTypeGroupSlashPath,
    BOM_SUB_TYPE: mastersBomSubTypePath,
    GET_COLOUR_DOCS: '/bom-supporting/colour-documents',
    GET_USERS: '/company/users',
    GET_CATEGORIES: '/categories-list',
    ADD_BOM_LIBARARY_TAGS: libraryBomTagsPath,
    GET_BOM_LIBARARY_TAGS: libraryBomTagsPath,
    GET_BOM_LIBARARYBYID_TAGS: libraryBomTagsPath,
    DOWNLOAD_BOM_LIBRARY: '/download-bom-library',
    BOM_EXCEL_SHEET_IMPORT: '/import-library-xlsx',
    GET_ALL_BOMS: '/bom-type/list',
    COMPONENT_SUB_TYPE: '/masters/component-sub-type-master',
  },
  BOM_LIBRARY_GROUP: {
    GET: bomLibraryGroupPath,
    GET_BY_ID: '/bom-library-group/',
    GET_SEASONS: mastersSeasonsPath,
    CATEGORY: '/masters/categories',
    CREATE: bomLibraryGroupPath,
    UPDATE: '/bom-library-group/',
    DELETE: bomLibraryGroupPath,
    SAVE_SEQUENCE: '/bom-library-group/sequence',
    GET_OPTIONS: '/bom-library-group-options',
  },
  BOM_LIBRARY_FETCH_REFERENCE_TYPE: {
    GET: mastersBomSubTypePath,
  },
  BOM_LIBRARY_FETCH_REFERENCE_SUPPLIER: {
    GET: '/company/main-suppliers',
    GET_SUPPLIER_FACTORIES: '/company/supplier/factories',
    GET_PRODUCT_DPP_bom: '/product-dpp/product-boms',
  },
  BOM_LIBRARY_FETCH_COMPOSITION: {
    GET: mastersMaterialCompositionPath,
  },
  BOM_LIBRARY_FETCH_UNIT_OF_MEASURE: {
    GET: mastersUnitsPath,
  },
  COLOR_LIBRARY: {
    GET: colourWaysPath,
    CREATE: colourWaysPath,
    PUT: colourWaysPath,
    DELETE: colourWaysPath,
    GET_GROUP: '/colour-groups',
    EDIT_GROUP: '/colour-groups',
    COLOUR_SUPPORTING_DOCUMENTS: '/colour-supporting/documents/upload',
    DELETE_UNSAVED_COLOUR_SUPPORTING_DOCUMENTS: '/colour-supporting/documents/delete',
    GET_COLOUR_SUPPORTING_DOCUMENT: '/colour-supporting/documents/change/',
    MERGED_PDF_PREVIEW: '/colour-lib/merged-pdfs',
    MERGED_PDF_DELETE: '/colour-lib/merged-pdfs',
    GET_LIST: '/colour-ways-list',
    GET_GROUP_LIST: '/colour-groups-list',
    DOWNLOAD_COLOURWAY_LIBRARY: '/download-colour-xlsx',
    UPLOAD_FILE: '/import-color-xls',
    GET_GROUP_LIST_PGINATION: '/list-colour-group',
  },
  AUTH: {
    GET: '/users/logout',
    RESET_PASSWORD: '/users/change-pwd',
    FORGOT_PASSWORD: '/users/forgot-password',
    LOGIN: '/users/login',
    SSO_MICROSOFT_AUTHORIZE: '/v1/auth/sso/microsoft/authorize',
    SSO_MICROSOFT_ENABLED: '/v1/auth/sso/microsoft/enabled',
    SSO_MICROSOFT_CONNECT: '/v1/auth/sso/microsoft/connect',
    SSO_MICROSOFT_DIRECTORIES: '/v1/auth/sso/microsoft/directories',
    SSO_GOOGLE_AUTHORIZE: '/v1/auth/sso/google/authorize',
    SSO_GOOGLE_ENABLED: '/v1/auth/sso/google/enabled',
    SSO_GOOGLE_CONNECT: '/v1/auth/sso/google/connect',
    SSO_GOOGLE_DIRECTORIES: '/v1/auth/sso/google/directories',
    SSO_SEAT_USAGE: '/v1/auth/sso/seat-usage',
    SSO_TICKET: '/v1/auth/sso/ticket',
    SET_SECURITY_QUESTIONS: '/users/securityQuestions',
    SIGN_UP: '/users/register',
    VERIFY_SECURITY_QUESTIONS: '/users/verify-security-questions',
    RESET_USER_PASSWORD: '/users/change-password',
    VERIFY_OTP: '/users/verify-otp',
    GET_MFA_QR_CODE: '/users/mfa-qrcode',
    ENABLE_MFA: '/users/enable-mfa',
    VERIFY_CODE: '/users/verify-code',
    RECOVER_MFA_ACCOUNT: '/users/recover-mfa-account',
    RECOVERY_REQUEST: '/users/recovery-request',
    USER_VERIFIED: '/users/is-verified',
    USER_VERIFY: '/users/verify',
  },
  NOTIFICATION: {
    GET: '/notification/',
    UPDATE: '/notification/',
    UPDATE_CLEAR: '/notification/clear/all',
    USER_NOTIFICATION_GET: '/user-notification',
    USER_NOTIFICATION_UPDATE: '/user-notification/update',
    USER_NOTIFICATION_LIST: '/user-notification/list',
    USER_NOTIFICATION_READ: '/user-notification/',
    USER_NOTIFICATION_ALL_CLEAR: '/user-notification/notification/all-clear',
  },
  NOTIFICATION_SETTINGS: {
    GET: '/users/notification/',
    UPDATE: '/users/notification',
  },
  BOM_CONFIG: {
    GET: '/product-bom/bom-types',
    POST: '/product-bom/bom-types',
    BOM_DEV_ORDER: '/product-bom/match-products',
    BOM_PRODUCT_SUGGESTION: '/product-bom/match-product-libs',
    BOM_GROUP_SUGGESTION: {
      GET: '/product-bom/bom-library-group',
      // CREATE: "/product-bom/library-group",
      GROUP_LIB_LIST: '/product-bom/library-group',
    },
    BOM_CARD_LIST: {
      // GET: "/product-bom/:bomType/:devOrderId",
      GET: productBomPath,
      IMPORT: '/product-bom/library',
      DELETE: productBomPath,
      CREATE: productBomPath,
      UPDATE: '/product-bom-edit',
      ADDTOLIBRARY: '/library',
      QUALITY_APPROVED: '/bom-approval',
      COLOUR_APPROVED: '/bom-color-approval',
      REMOVE_QUALITY_APPROVED: '/bom-approval',
      REMOVE_COLOUR_APPROVED: '/bom-color-approval',
      SAVE_MULITPLE_BOMS: '/multi-bom-save',
      ADD_BOM_LIBARARY: '/add-bom-to-libraries',
    },
    BOM_SUPPLIER: orderSupplierPath,
    SAVE_SEQUENCE: '/bom-sequence',
    ADD_BOM_TAG: '/bom-tags',
    GET_BOM_TAG: '/bom-tags',
    GET_BOM_BYID: '/bom-tags',
    FETCH_FILTERED_BOMS_LIST: '/bom-library/filtered-list',
  },

  USER_RIGHTS: {
    GET: '/bom-rights',
    GET_USERS_GROUPS_CARD: userGroupsPath,
    POST_USERS_GROUPS_CARD: userGroupsPath,
    DELETE_USERS_GROUPS_CARD: userGroupsPath,
    UPDATE_USERS_GROUPS_CARD: userGroupsPath,
    GET_USERGROUPS_BYID: userGroupsPath,
    PUT_USERGROUPS: '/users',
    GET_COMPANY_SUBSCRIPTION_DETAILS: '/module-subscription-permission',
    GET_COMPANY_RIGHTS: '/users/company-rights',
  },
  USER_LIBRARY: {
    GET_USERS_LIBRARY_LIST: '/company/users',
    GET_SUPPLIER_USERS_LIST: '/supplier/users',
    DELETE_USERS_LIBRARY: '/company/users/delete',
    UPDATE_USERS_LIBRARY: '',
    RESET_USERS_PASSWORD: '/users/resend-set-password-link-email',
    UPDATE_USERS_LIBRARY_STATUS: '/company/users/change-state',
    ADD_USER: '/company/users/add',
    EDIT_USERS: '/company/users/edit',
  },
  USER_ACCOUNT_DETAILS: {
    PROFILE_DETAILS: '/company/profile',
    EDIT_PROFILE_DETAILS: '/company/profile/edit',
    CHANGE_PASSWORD: '/users/change-pwd',
    GET_SUPPLIER_PROFILE: '/supplier/profile',
    EDIT_SUPPLIER_PROFILE: '/supplier/profile/edit',
    GET_USER_DETAILS: '/users/profile',
    EDIT_USER_DETAILS: '/users/profile/edit',
    SET_PASSWORD: '/users/set-new-password',
    CURRENCY_PERMISSION: '/company/currency-permission',
    GET_STORAGE_USED_SLUGS: '/company/storage-used-slugs',
  },
  ORDER_PERMISSION: {
    GET: '/orders/permisson',
  },
  FETCH_PRODUCT_LIST: {
    GET: developmentOrdersPath,
    POST: '',
  },
  GET_TRAFFIC_LIGHTS: {
    GET: '/development-orders/traffic-lights',
  },
  DELETE_BOM_APPROVAL: {
    DELETE: '/bom-approval/:bomType/:devOrderId',
  },
  GET_ACCESS_MODULES: {
    POST: '/development-orders/accessModules',
  },
  PLACEHOLDER_MANAGEMENT: {
    POST: '/placeholder-management/add',
  },
  SUPPLIER: {
    POST: '/supplier/add',
    GET: '/company/suppliers-list',
    PUT: '/supplier/edit/',
    GET_SINGLE_SUPPLIER: '/company/suppliers/',
    SUGGEST_SWITCH: '/supplier/edit/suggest/',
    ACTIVE_STATE: '/company/suppliers/',
    DELETE: '/supplier/delete/',
    INTEGRATE_SUPPLIER: '/supplier/resend-confirmation-mail',
    GET_T1: '/tier1-suppliers',
    GET_PRODUCTSUPPLIER: orderSupplierPath,
    GET_T2_HIGHER: '/high-tier-suppliers',
    GET_FACTORY_SUPPLIERS: '/component-suppliers',
    GET_ALL_TIER: '/all-tier-suppliers',
    SUPPLIER_BRAND: '/supplier-brands',
    GET_USER_SUPPLIERS: '/masters/user-suppliers',
    GET_SUPPLIER_TYPE_LIST: '/company/supplier-type-list',
    SUPPLIER_TAGS: '/supplier/supplier-tags',
    REGISTER_SUPPLIER: '/supplier/register',
    CHECK_LINK_EXPIRATION: '/supplier/is-link-expired',
    CHECK_EMAIL_VERIFICATION: '/supplier/verify',
    SUPPLIER_USERLIST: '/supplier/user-list',
    SEND_FACTORY_UPDATE: '/supplier/send-factory-update-link',
    COMMON_SUPPLIER_TEMPLATE: '/supplier-templates',
    GET_SUPPLIER_TEMPLATE: '/supplier-templates-all-detail',
    SUPPLIER_TEMPLATE: '/supplier-template',
    SAVE_SUPPLIER_DOCUMENT_TEMPLATE: '/supplier-document-template',
    EDIT_SUPPLIER_TEMPLATE: '/supplier-doc-template',
    ARCHIVE_UNARCHIVE: '/supplier-document-template/archive',
    DUPLICATE_TEMPLATE: '/duplicate-template',
    IS_COMPLETE: '/supplier-document-template/is-complete',
    DOCUMENT_TEMPLATE: '/supplier-template-by-document',
    DUPLICATE_DOCUMENT: '/supplier-doc/duplicate',
    UPDATE_DOCUMENT: '/supplier-document',
    DOWNLOAD_TEMPLATE: '/download-supplier-document-template',
    UPLOAD_SCM_IMAGE: '/upload-scm-image-s3',
    SCM_IMAGE_DELETE: '/delete-scm-image',
    GET_DOC_STATUS: '/doc-status',
    SUPPLIER_MODULE_LIST: '/template-module-page-list',
    GET_NEW_PAGEID: '/template-module-new-page',
    PARTNER_MODULE_PAGE_CONTROLS: '/get-partner-page-controls',
    PARTNER_MODULE_PAGES: '/template-module-page-source-list',
    DELETE_PAGE_ID: '/template-module-delete-page',
    TEMPLATE_SEQUENCE: '/template-page-rearrange',
    TEMPLATE_CONTENT_PAGE: '/template-content-page',
    DOUCUMENT_TEMPLATE_LIST: '/document-template-page-list',
    PARTNER_MODULE_DEPENDENT_CONTROLS: '/get-partner-dependent-page-controls',
    REFERESH_TEMPLATE: '/refresh-supplier-files',
    REFERESH_TEMPLATE_PAGE: '/refresh-supplier-file-pages',
    DUPLICATE_SUPPLIER_FILE_PAGE: '/supplier-file-pages-duplicate',
    GET_SUPPLIER_FILE_CONTENT_PAGE: '/get-supplier-files-content-page',
    GET_TIERS: '/tiers-suppliers',
    GET_PARTNER_CALCULATION_PAGE: '/get-partner-page-calculation-controls',
    EXPORT_SELECTED: '/supplier/export-selected',
    EXPORT_ALL: '/supplier/export-all',
    DOWNLOAD_SAMPLE_TEMPLATE: '/supplier/download-template',
    TIER_SUPPLIERS_LIST: '/supplier/tiers-suppliers-list',
    UPLOAD_PRESIGNED_URL: '/supplier/upload-presigned-url',
  },
  SUPPLIER_USER: {
    POST: '/supplier/users/add',
    GET: '/supplier/users/',
    PUT: '/supplier/users/edit/',
    DELETE: '/supplier/users/delete/',
    UPDATE_STATUS: '/supplier/users/change-state/',
    MULTIDELETE_USER: '/supplier/users/delete',
    SET_PASSWORD: '/users/resend-set-password-link-email',
    CHECK_PASS_LINK_EXP: '/users/is-set-password-link-expired',
    SET_NEW_PASSWORD: '/users/set-password',
  },
  COMPONENT_SUPPLIER: {
    POST: '/factory/add',
    GET: '/factory/list/',
    PUT: '/factory/edit/',
    DELETE: '/factory/delete',
    GET_SINGLE_FACTORY: '/factory/',
    GET_FACTORY_TAGS: '/factory/get-factory-tags/',
    GET_MULTIPLE_SUPPLIER_DATA: '/factory/get-supplier-factory',
    ACTIVE_STATE: '/factory/',
    ACTIVE_STATES: '/factory/active-states',
  },
  USER_MANAGEMENT: {
    RIGHTS_ASSIGNMENT: '/users/rights-assignment',
    GET_MASTERS_BRANDS: '/masters/brands',
    GET_MASTERS_CATEGORIES: '/masters/categories',
    GET_COMPANY_USERS: '/company/company-users',
    GET_ADMIN_LIST: '/company/admin',
  },
  REQUIRED_DOCUMENT: {
    DOC_TYPE: '/doc-type',
  },
  BOM_DUE_DATE: {
    POST: bomDueDatePath,
    GET: bomDueDatePath,
    DELETE: bomDueDatePath,
  },
  SUPPLIER_DOCUMENT: {
    SUPPLIER_DOC: '/supplier-doc',
    SUPPLIER_DOC_STATUS: '/supplier-doc/status',
    RENEW_DOCUMENT: '/supplier-doc/renew/',
    PENDING_TYPE_DOCUMENT: '/supplier-doc/remaining-type',
  },
  DEVELOPMENT_ORDER: {
    ADD_DEV_ORDER: developmentOrdersPath,
    BULK_UPDATE_DEV_ORDER: `${developmentOrdersPath}/bulk`,
    PRODUCT_DEPENDENT_DATA: '/dependent-data',
    GET_DEV_ORDER: '/get-development-orders',
    ADD_DESC_DEV_ORDER: '/development-orders-description',
    GET_ORDER_MEASURENT: '/order-measurements/',
    SET_ORDER_MEASURENT: '/order-measurements/annotate/',
    GET_DESIGN_DETAIL: developmentOrdersPath,
    GET_SET_DESIGN_DETAIL: developmentOrdersPath,
    GET_SET_SAMPLES: '/orders-samples/annotae-images',
    FETCH_COLOURS: '/order/colourways',
    FETCH_LENGTHS: '/order/legLengths',
    FETCH_SIZES: '/order/sizes',
    UPLOAD_SUMMERNOTE_IMAGES: '/orders-samples/summernote-images',
    SUBMIT_DOWNLOAD: '/order-submit-download',
    GRADING: '/gradings',
    CADLIB: '/order-pattern-libraries',
    CADSPECIFICATIONLIB: '/pattern-libraries',
    MARK_COMPLETE: developmentOrdersMarkCompletePath,
    EDIT_RULES: '/development-orders/edit-rules',
    CHANGE_GRADING: '/development-orders/change-grading',
    ARCHIVE_PRODUCT: '/development-orders/archive',
    TRASH_PRODUCT: '/development-orders/trash',
    CHANGE_PRODUCT_STATUS: '/development-orders/change-products-status',
    SPECSPECIFICATIONLIB: '/spec-template-libraries',
    ALL_SPECT_TEMPLATE: 'all-spec-template-libraries',
    FETCHCADFROMPRODUCT: orderPreviousStylesPath,
    FETCH_CADFILES_FROM_PRODUCT: '/order/measurment',
    GET_SET_GRADING: '/order-measurements/gradings',
    GET_UNITS: mastersUnitsPath,
    ADD_IMAGE_TO_LIBRARY: '/order-measurements/add-to-libray',
    ADD_CAD_FILE: '/order-measurements/upload',
    IMPORT_XL_FILE: gradingsImportXlsPath,
    IMPORT_SPECIFICATION_XLS: '/specification-imports',
    GET_OHTER_DOCUMENT: '/order-measurements/documents',
    SET_PERMISSION: ordersPermissonSamplePath,
    SET_PERMISSION1: '/orders/permisson',
    GET_TEST_REPORT: '/order-testing-report',
    SPECLIB: '/order-spec-libraries',
    PRODUCT_TAGS: '/product-tags',
    PRODUCT_GROUP: '/product-groups',
    ADD_PRODUCT_GROUP: '/add-product-to-groups',
    BULK_SUBNIT_DOWNLOAD: '/development-orders/multi-submit-download',
    GET_BULK_SUBNIT_DOWNLOAD: '/multi-submit-download',
    ADD_PRODUCT_GROUP_DATA: '/add-product-to-groups',
    PRODUCT_REORDER: '/reOrder',
    PRODUCT_UNLINK: '/development-orders/unlink',
    REORDER_LIST: '/reOrders-list/reOrder',
    IS_SAME_SUPPLIER_EXIST: '/issame-supplier-exist',
    UPDATE_SPEC_POMS: '/add-update-spec-poms',
    GET_SELECTED_GRAD_MEASUREMENTS: '/order-measurements/grading-group-measurments',
    UPDATE_SELECTED_GRAD_MEASUREMENTS: '/order-measurements/grading-group-measurments',
    CHECK_IF_PRODUCT_MEASUREMENTS_EXISTS: '/product-measurements-exists',
    ALL_OPEN_PRODUCTS: '/all-open-products',
    POST_PERMISSION: '/orders/permisson',
    CUSTOM_MODULE: '/custom-module-list',
    CUSTOM_MODULE_ADD_EDIT: '/product-custom-module',
    FETCH_CUSTOM_MODULE: '/get-product-custom-libraries',
    CUSTOM_MODULE_PERMISSION: '/orders/permisson/additionalInfo',
    REFRESH_CUSTOM_MODULE: '/refresh-product-custom-module',
    GET_PRODUCT_IDENTIFIER: '/product-identifier',
    CM_IMAGE_DELETE: '/delete-cm-image',
    CM_PAGE_IMAGE_DELETE: '/delete-cm-page-image',
    PRODUCT_CM_PAGE_LIST: '/product-custom-module-page-list',
    PRODUCT_DELETE_CM_PAGE: '/delete-product-custom-libraries',
    PRODUCT_CM_COPY_PAGE: '/product-custom-module-page-duplicate',
    PRODUCT_DEPENDENT_CONTROL_LIST: '/get-product-dependent-page-controls',
    FETCH_CM_CONTENT_PAGE: '/get-product-content-page',
    FETCH_PRODUCT_NAME: '/get-product-name',
    CHECK_PRODUCT_DAM_EXIST: '/product-dam/check-product-dam-exist',
    DELETE_ALL_PRODUCT_DAM: '/product-dam/delete-all-product-dam',
    REFRESH_CUSTOM_MODULE_PAGES: '/refresh-product-custom-module-pages',
    GET_DPP_MODULE_LIST: '/product-dpp/dpp-module-list',
    DOWNLOAD_TESTING_USAGE: '/download-testing-usage',
    PRODUCT_DOWNLOAD_TESTING_USAGE: '/product-download-testing-usage',
    GET_ALL_COUNTS: '/get-next-counter',
    CHECK_PRODUCT_BOM_EXIST: '/product-bom/check-product-bom-exist',
    DELETE_ALL_PRODUCT_BOM: '/product-bom/delete-all-product-bom',
    GET_BOM_DETAILS_ID: '/product-bom/get-bom-details',
    GET_UPDATE_LATEST_COUNTER: '/update-latest-counter',
    SUPPLIER_SUGGESTION_ID: '/supplier-suggestion/product-info',
    CHANGE_FACTORY: '/product-cp/delete-factory-related-data',
    BULK_CREATE_DEV_ORDER: `/v1${developmentOrdersPath}/bulk`,
  },
  DESIGN_DETAILS: {
    ADD_DESIGN_DETAIL: '/design-details',
    FIRST_PART: developmentOrdersPath,
    GET_DOCUMENT_LIST: '/order-document/list',
    GET_MANUAL_DOCUMENT_LIST: '/document',
    PERMISSIONS: '/orders/permisson/design',
    COMPLETION: developmentOrdersMarkCompletePath,
    ARCHIVE_REPORT: 'archive-design',
    UNARCHIVE_REPORT: 'unarchive-design',
    APPROVE_REJECT_DESIGN: 'design/add-status',
    REMOVE_DESIGN_STATUS: 'design/remove-status',
    REPLACE_DESIGN: 'replace-design',
    DUPLICATE_DESIGN: 'duplicate-design',
    CROP_DEFAULT_DESIGN: '/design-details/crop-default-design',
    GET_SUPPORTINGDOC: 'design-details-supporting-doc',
    MARK_DEFAULT: '/design-details/mark-default',
    SAVE_SEQUENCE: '/design-details/save-sequence',
    CREATE: '/design-details/create',
    SAVE_IMAGE: '/design-details',
    SAVE_IMAGE_SEQUENCE: '/design-details',
    SAVE_COMMENT: '/design-details/save-comment',
    SAVE_PDF_EXCLUDED_COMMENT: '/pdf-excluded-comment',
    SAVE_ANNOTATION: '/design-details',
    REPLACE_IMAGE: '/design-details',
    SINGLE_TITLE_SAVE: '/single-save',
    GET_SINGLE_DESIGN: '/design-details/get-single-design',
    DELETE: '/design-details/delete',
    BULK_DELETE: '/design-details/bulk-delete',
    DELETE_IMAGE: '/design-details',
  },
  SAMPLES: {
    GET_SUPPLIER: orderSupplierPath,
    GET_MAIN_SAMPLES: '/masters/mainSamples',
    GET_OTHER_SAMPLES: '/masters/otherSamples',
    GET_SAMPLES: ordersSamplesPath,
    GET_SAMPLES_BY_ID: '/orders-samples/',
    ADD_SAMPLE: ordersSamplesPath,
    EDIT_SAMPLE: '/orders-samples/',
    ADD_SAMPLE_TRACKING: '/orders-samples/tracking',
    // DELETE_SAMPLES: "/delete-orders-samples/",
    SET_SAMPLES_PERMISSION: ordersPermissonSamplePath,
    GET_SAMPLES_PERMISSION: ordersPermissonSamplePath,
    SAMPLE_ANNOTATIONS: '/orders-samples/annotae-images',
    SAVE_SAMPLE_ANNOTATIONS: '/orders-samples/annotae-images/all-images',
    SAVE_SAMPLE_IMAGE_SETS_SEQUENCE: '/order-sample/image-sets/rearrange',
    SAVE_SUPPLIER_IMAGE_SETS_SEQUENCE: '/order-sample/supplier-image-sets/rearrange',
    SAVE_SAMPLE_IMAGES_SEQUENCE: '/order-sample/images/rearrange',
    SAVE_SAMPLE_ANNOTATION_SEQUENCE: '/order-sample/annotation/rearrange',
    SAVE_SUPPLIER_ANNOTATION_SEQUENCE: '/order-sample/supplier-annotation/rearrange',
    SAVE_SUPPLIER_IMAGES_SEQUENCE: '/order-sample/supplier-images/rearrange',
    UPDATE_SAMPLE_IMAGES: '/order-sample/sample-images',
    UPDATE_SUPPLIER_IMAGES: '/order-sample/supplier-images',
    SAVE_SAMPLE_IMAGES: ordersSamplesPath,
    SIZE_SAMPLE_MEASUREMENT: '/sample-orders/sample-measurement',
    GRADING_GROUP_MEASUREMENTS: '/sample-orders/grading-group-measurements',
    DELETE_SAMPLES: ordersSamplesPath,
    UPLOAD_IMG: '/sample/upload-image',
    MISSING_COMPONENT: '/orders-bom',
    MISSING_COMPONENT_SAVE: '/dashboard/bom',
    ADD_COMMENT: '/sample/comment',
    GET_COMMENTS: '/sample/comment',
    GET_SINGLE_COMMENT: '/sample/sample-comment',
    UPDATE_COMMENT: '/sample/sample-comment',
    DELETE_COMMENT: '/sample/delete-sample-comment',
    COMMENT_READ: '/sample/comment-read',
    SAMPLE_TRAKING: '/masters/sample-tracking',
    SAMPLE_ACTIVETAB_ADD_DATA: ordersSamplesPath,
    SAVE_SPECIFICATION_SUPPLIER_COMMENT: '/orders-samples/supplier',
    SAVE_SPECIFICATION_SUPPLIER_COMMENT_MULTI: '/orders-samples/supplier-comments-multi',
    BULK_DATES_UPLOAD: '/dashboard/save-tracking-dates',
    EDIT_SAMPLE_SPECIFICATIONS: '/orders-samples/sample-specification',
    EDIT_SAMPLE_SPECIFICATIONS_MULTI: '/orders-samples/specifications-multi',
    REPLACE_SAMPLE_IMAGE: '/replace-sample-image',
    REPLACE_SUPPLIER_IMAGE: '/replace-supplier-image',
    GET_PAGINATION_SAMPLES: '/samples',
    SAMPLES_LIST_EXPORT_EXCEL: '/sample/samples-list-export',
    GET_SAMPLE_TYPE_GROUPS_BY_PRODUCT: '/sample-type-groups-by-product',
    GET_SAMPLE_DROPDOWN_OPTIONS: '/orders-samples/dropdown-options',
    GET_SAMPLE_VERSION_LIST: '/orders-samples/version-list',
    UPDATE_SAMPLE_PRIORITY: '/orders-samples',
    BULK_UPDATE_SAMPLE_PRIORITY: '/orders-samples/bulk-priority',
    BULK_UPDATE_SAMPLE_STATUS: '/orders-samples/bulk-status',
  },
  SUPPLIER_SUGGESTION: {
    GET: '/demo/',
    GET_COMPONENT: mastersBomSubTypePath,
    GET_COMPOSITION: mastersMaterialCompositionPath,
    GET_UNITS: mastersUnitsPath,
    GET_PRODUCT_REF: '/development-orders/supplier-orders',
    GET_SUPPLIER: '/company/main-suppliers',
    GET_BOM_TYPE: '/supplier-suggestion/bom-types',
    GET_BOM_COMPONENT: '/supplier-suggestion/bom-component',
    ADD_SUPPLIER_SUGGESTION: '/supplier-suggestion/add',
    SUPPLIER_SUGGESTION_LIST: '/supplier-suggestion/list',
    SUPPLIER_SUGGESTION_DETAIL: '/supplier-suggestion/detail',
    SUPPLIER_SUGGESTION_DELETE: '/supplier-suggestion/delete',
    APPROVE_SUGGESTION: '/supplier-suggestion/approval',
    REJECT_SUGGESTION: '/supplier-suggestion/rejection',
    GET_SEASONS: mastersSeasonsPath,
    UPDATE_SUPPLIER_SUGGESTION: '/supplier-suggestion/update',
    GET_USER_SUPPLIERS: '/masters/user-suppliers',
    GET_EXISTING_SUGGESTION: '/supplier-suggestion/existing-suggestion',
  },
  TESTING_SUGGESTION: {
    GET_BOM_COMPONENT: '/product-bom/ref-codes',
    GET_COLOUR_WAYS: colourWaysPath,
    GET_TESTING_LIBRARIES: orderTestingPath,
    GET_TESTING_LIBRARY_BYID: '/order-testing-library',
    GET_ORDER_MEASURENT: '/order-measurements',
    GET_CARE_LABEL: '/care-label',
    GET_MEASUREMENT_PERMISSON: '/orders/permisson/measurement',
    SAVE_MEASUREMENT_PERMISSON: '/measurements/permisson',
    GET_CARELABEL_PERMISSON: '/orders/permisson/care-label',
    GET_GRADING: '/order-measurements/gradings',
    SUGGESTION_UPLOAD_IMG: '/supplier-suggestion/upload-image',
    SUGGESTION_UNLINK_IMG: '/supplier-suggestion/unlink-image',
  },
  POM: {
    GET_ALL_POM: '/point-of-measures',
    ADD_POM: '/point-of-measures',
    UPDATE_POM: pointOfMeasuresPath,
    DELETE_POM: pointOfMeasuresPath,
    MULTI_DELETE_POM: pointOfMeasuresPath,
    UNIQUE_POM_CODE: '/point-of-measures/is-unique',
    GET_GRADING_GROUP: '/gradings',
    GET_GRADING_NAME: '/gradings-list',
    EDIT_GRADING_GROUP: '/libraries/gradings/edit',
    ADD_GRADING_GROUP: '/libraries/gradings/add',
    GRADING: '/gradings',
    GRADING_GROUP_POMS: '/gradings',
    POM_EXCEL_SHEET_UPDATE: '/gradings/import-xls',
    DUPLICATE_GRADING: '/duplicate-grading-group',
    UPDATE_GRADING_STATUS: '/gradings/update-status',
    DOWNLOAD_POM_LIBRARY: '/download-pom-xlsx',
    UPLOAD_POM_EXCELSHEET: '/upload-pom-xlsx',
    SAVE_POM_GROUP: '/point-of-measures/groups',
    GET_POM_GROUPS: '/point-of-measures-groups',
    FETCH_POM_GROUPS: '/point-of-measures-groups-library',
    DOWNLOAD_SAMPLE_FILES: '/download-grading-sample-xlsx',
  },
  SYSTEM_MASTER: {
    MY_TODO_FILTER_MASTERS: '/masters/my-todo-filter-masters',
    GET_ALL_BRANDS: '/masters/brands',
    GET_ALL_SEASONS: mastersSeasonsPath,
    GET_ALL_CATEGORY_1: mastersFetchCategoriesPath,
    GET_ALL_CATEGORY_2: mastersFetchCategoriesPath,
    GET_ALL_CATEGORY_3: mastersFetchCategoriesPath,
    GET_ALL_CATEGORY_4: mastersFetchCategoriesPath,
    GET_MULTI_CATEGORIES: '/masters/categories-multi-filter',
    GET_ALL_LENGTHS: '/masters/leg-lengths',
    GET_ALL_COMPOSITIONS: mastersMaterialCompositionPath,
    GET_ALL_MATERIAL_PLACMENT: '/masters/material-placement-component',
    GET_ALL_LABEL_PLACMENT: '/masters/label-placement',
    GET_ALL_MAIN_SAMPLE: '/masters/mainSamples',
    GET_ALL_PC_TYPE: '/masters/supplier-type',
    GET_ALL_OTHER_SAMPLES: '/masters/otherSamples',
    GET_ALL_PO_SIZE_MASTER: '/masters/sizes',
    SIZE_RANGES: '/masters/size-ranges',
    BULK_SAVE_SIZE_RANGES: '/masters/size-ranges/bulk-save',
    GET_ALL_BOM_TYPE_MASTER: '/bom-type',
    GET_ALL_BOM_SUB_TYPE_MASTER: mastersBomSubTypePath,
    GET_ALL_BOM_SUB_COMPONENT_MASTER: '/masters/component-sub-type-master',
    GET_ALL_PRODUCT_STATUS_MASTER: '/masters/product-status-type',
    SET_DEFAULT_PRODUCT_STATUS: '/masters/set-default-product-status',
    GET_ALL_UNIT_MASTER: mastersUnitsPath,
    GET_NEW_ACCORDIAN: '/masters/custom-type-master',
    POST_NEW_ACCORIAN: '/masters/custom-type-master',
    GET_ALL_FOR_CUSTOM_ACCORDIAN: '/masters/custom-type',
    GET_SAMPLE_TRACKING: '/masters/sample-tracking',
    GET_SAMPLE_STATUS: '/masters/sample-status',
    GET_MEASUREMENT: '/masters/measurement',
    SET_ST_SEQUENCE: '/masters/sample-tracking-sequence',
    SET_SS_SEQUENCE: '/masters/sample-status-sequence',
    GET_CUSTOM_ATTRIBUTE: '/masters/custom-attribute-master',
    PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE: '/masters/partner-overview-custom-attributes',
    PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_USAGE: '/masters/partner-overview-custom-attributes/usage',
    PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_ACTIVE: '/masters/partner-overview-custom-attributes/active-state',
    PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_SEQUENCE: '/masters/partner-overview-custom-attributes/sequence',
    SET_CUST_ATTR_SEQUENCE: '/masters/custom-attribute-sequence',
    GET_ALL_FINALS: '/masters/finished-type',
    GET_ALL_INCOTERMS: '/masters/incoterms',
    EXCHANGE_RATE: '/masters/exchange-rate',
    SET_MM_SEQUENCE: '/masters/measurement-sequence',
    SET_MASTER_ACCESS: '/masters/system-master-access',
    GET_PLACEMENT: '/masters/placement',
    SET_PM_SEQUENCE: '/masters/placement-sequence',
    GET_USER_BRANDS: '/masters/user-brands',
    GET_USER_CATEGORIES: '/masters/user-categories',
    ADD_PORT_OF_LANDING: '/masters/add-landing',
    GET_PORT_OF_LANDING: '/masters/get-landing',
    DELETE_PORT_OF_LANDING: '/masters/delete-landing',
    SET_CS_SEQUENCE: '/masters/costing-stage-sequence',
    GET_CS_ITEM: '/masters/costing-stage',
    ADD_GROUP_PRODUCT: '/masters/product-group-master',
    SET_PRODUCT_SEQUENCE: '/masters/product-group-sequence',
    GET_DOCUMENT_TYPE: '/masters/document-type',
    SET_DOCUMENT_TYPE_SEQUENCE: '/masters/document-type-sequence',
    PRODUCT_IDENTIFIER: '/masters/product-identifier',
    PRODUCT_IDENTIFIER_CHANGE: '/masters/product-identifier-change',
    PRODUCT_IDENTIFIER_SEQUENCE: '/masters/product-identifier-sequence',
    TEST_TYPE_MASTER: '/masters/test-type-master',
    TEST_SEQUNCE_MASTER: '/masters/test-type-seq-master',
    GET_DAM_ATTRIBUTE: '/masters/dam-attribute-master/list',
    SUPLLIER_STATUS_MASTER: '/masters/supplier-status-master',
    SET_DAM_ATTR_SEQUENCE: '/masters/dam-attribute-sequence',
    SET_SUPPLIER_STATUS_SEQUENCE: '/masters/supplier-status-sequence',
    GET_MANUAL_DOCUMENT_TYPE: '/masters/manual-document-type',
    SAVE_MANUAL_DOCUMENT_TYPE_SEQUENCE: '/masters/manual-document-type-sequence',
    AUTO_ID_GENERATOR: '/masters/auto-id-generator-master',
    GET_UPDATE_LATEST_COUNTER: '/masters/update-latest-counter',
    GET_MULTI_CUSTOM_ATTRIBUTE: '/masters/multi-custom-attribute-master',
    ACTIVE_INACTIVE_CUSTOM_ATTRIBUTE: '/masters/active-inactive-multi-custom-attribute-master',
    SET_MULTI_CUSTOM_ATTRIBUTE_SEQUENCE: '/masters//multi-custom-attribute-sequence',
    GET_CUSTOM_BOMATTRIBUTE: '/masters/bom-custom-attribute-master',
    SET_CUST_BOM_SEQUENCE: '/masters/bom-custom-attribute-sequence',
    GET_MODULE_ORDER_ITEMS: '/masters/module-order-items',
    GET_MODULE_ORDER_ITEMS_FOR_PRODUCT: '/masters/module-order-items-for-product',
    GET_MODULE_ORDER_CONFIGS: '/masters/module-order-configs',
    SET_MODULE_ORDER_SEQUENCE: '/masters/module-order-sequence',
    GET_CUSTOM_ATTRIBUTE_VALUE: '/masters/update-custom-attribute-master',
    FETCH_TYPE_BASED_CATEGORY: '/masters/fetch-type-based-category',
    GET_LENGTH_ACCESS: '/masters/length-access',
    GET_LENGTH_IN_USE_STATUS: '/masters/lengths/in-use-status',
    SET_LICENSOR_ACCESS: '/masters/licensor-master-access',
    GET_LICENSOR_ACCESS: '/masters/licensor-master-access',
    GET_ALL_LICENSOR: '/masters/licensor',
    GET_ALL_LICENSE: '/masters/license',
    GET_ALL_LIKENESS: '/masters/likeness',
    GET_ALL_SUB_BRAND: '/masters/sub-brand',
    GET_ALL_PLACEMENT_SUB_BRAND: '/masters/get-all-sub-brand',
    GET_SUB_BRAND_ACCESS: '/masters/sub-brand-toggle',
    GET_MULTI_SUB_BRAND: '/masters/multi-sub-brand',
    SET_INCOTERMS_FOR_LICENSE: '/masters/incoterms-for-license',
    GET_CUSTOM_ATTRIBUTE_DETAIL: '/masters/custom-attribute-detail',
    GET_PLACEMENT_NAMES: '/masters/placement-names',
    GET_CAT_BASED_ON_PT: '/masters/cat-based-on-pt',
    COMPOSITION_PROCESS: '/masters/composition-process-master',
    GET_BOM_COMPONENT_TYPE: '/masters/bom-component-type',
    PRODUCT_TYPE_PROCESS: '/masters/product-type-process',
    GET_BOM_SOURCE_CUSTOM_ATTRIBUTE: '/masters/bom-source-custom-attribute',
    GET_ALL_COLOUR_GROUPS: '/get-all-colour-group',
    SAMPLE_TYPE_GROUP: '/masters/sample-type-group',
    CHECK_SAMPLE_TYPE_IN_USE: '/masters/sample-type-group/check-sample-type-in-use',
    CHECK_AUTOMATION_CONFIG_IN_USE: '/masters/sample-type-group/check-automation-config-in-use',
    CHECK_SAMPLE_TYPE_GROUP_IN_USE: '/masters/sample-type-group/check-group-in-use',
    SAMPLE_TYPE_GROUP_IN_USE_ATTRIBUTE_VALUES: '/masters/sample-type-group/in-use-attribute-values',
    ADDITIONAL_VARIABLES: '/masters/additional-variables',
    GET_ADDITIONAL_VARIABLES_BY_PRODUCT: '/masters/additional-variables-by-product',
    ADDITIONAL_VARIABLES_IN_USE_STATUS: '/masters/additional-variables/in-use-status',
  },
  ASSET_LIBRARY_FILTER: {
    BASE_PATH: '/system-master/asset-library/filters',
    VALUES_BY_KEY: '/system-master/asset-library/filters/values-by-key',
  },
  ASSET_LIBRARY_HOME: {
    BASE_PATH: '/asset-library',
    HOME: '/asset-library/home',
    CHANNELS: '/asset-library/channels',
  },
  ASSET_LIBRARY_ASSETS: {
    BASE_PATH: '/asset-library',
    ASSETS: '/asset-library/assets',
    TAGS: '/asset-library/assets/tags',
    SHARE_CONTACTS: '/asset-library/assets/share/contacts',
    COMPANY_USERS: '/asset-library/assets/company-users',
    CUSTOM_FORMATS: '/asset-library/assets/custom-formats',
    SEARCH: '/asset-library/assets/search',
  },
  PRODUCT_TESTING: {
    GET_ALL_TESTINGS: orderTestingPath,
    GET_ALL_TESTINGS_MULTI_PRODUCT: '/order-testing-multiproducts',
    GET_ALL_BOM_LIST: '/product-bom/ref-codes',
    GET_ALL_COLOUR_LIST: colourWaysPath,
    GET_ALL_LIB_LIST: '/order-testing-libraries',
    GET_ALL_GROUP_LIST: '/order-testing-groups',
    GET_ALL_TEST_REPORT: '/testing/products',
    GET_ALL_PRODUCT_FOR_BOM: '/bom-library/products',
    GET_ALL_PRODUCT_REFS: '/open-products',
    GET_ALL_PRODUCTS: orderPreviousStylesPath,
    GET_ALL_PRODUCT_LIST: '/order/testing-requirements',
    POST_TO_LIBRARY: '/order-testing-library',
    POST_TO_LIBRARY_TEST: orderTestingPath,
    POST_TO_GROUP_TEST: '/order-testing-groups',
    POST_TEST_COMMENT: '/orders/permisson/testing',
    SAVE_SEQUENCE: '/sequence',
    GET_REPORTS: '/orders/reports/testing',
    DELETE_REPORTS: '/orders/reports/care-label',
    DELETE_REPORTS_TESTING: '/orders/reports/testing',
    POST_REPORTS: '/orders/testing-reports',
    GET_ARCHIVE_REPORT: '/orders/testing-reports-archived',
    POST_FROM_BOM: '/product-bom/testing-requirements',
    POST_FROM_TEST_ATTRI: '/testing/products',
    POST_TESTING_REPORT: '/orders/reports',
    RENEW_TESTING_REPORT: '/orders/testing-reports',
    GET_FILTEREDREPORTS: '/testing/report/filters',
    ORDER_TESTING_FROM_PRODUCT: '/order-testing-library/products',
    MULTI_PRODUCT_COSTING_ADD: '/product-costing/multi-add',
    CLEAR_HIGHLIGHT: '/clear-highlight/testing',
  },
  COSTING_TEMPLATE: {
    COMMON_API_PATH: '/costing-template',
    ADD_COSTING_TEMPLATE: '/costing-template/add',
    GET_COSTING_TEMPLATE_LIST: '/costing-template/list',
    UPDATE_COSTING_TEMPLATE_NAME: '/costing-template/name',
    DELETE_COSTING_TEMPLATE: '/costing-template/delete',
    COMMON_COSTING_COLUMN: '/costing-template/column',
    COPY_COSTING_TEMPLATE: '/costing-templte/copy',
    UPDATE_ADDITIONAL_SEQUENCE: '/costing-template/update-sequence',
    UPDATE_LANDED_SEQUENCE: '/costing-template/update-landed-sequence',
    MULTI_DELETE_SEQUENCE: '/costing-template/multiple',
    CUSTOM_COSTING_TEMPLATE: '/costing-template/custom-section',
    COSTING_ACTIVE_INACTIVE: '/costing-template/active-inActive',
    UPDATE_COSTING_ALL_CHANGES: '/costing-template/update-all-changes',
    COSTING_TEMPLATE_NEW_INFO_DETAILS: '/costing-template/costing-details',
    GET_COSTING_TEMPLATE_LIST_BY_DEV_ORDER: '/costing-template/list',
  },
  TESTING: {
    ALL_TESTING: '/testing-libraries',
    UPLOAD_FILE: gradingsImportXlsPath,
    ALL_GROUPS: '/testing-groups',
    ALL_LIBRARY: '/testing-libraries',
    GET_TESTING_ATTRIBUTES: '/product-bom/testing-requirements',
    TESTING_REPORTS: '/testing/reports',
    STATUS_CHANGE: '/testing/status',
    GET_ARCHIVE_REPORTS: '/testing/reports/archived',
    DELETE_TESTING_REPORT: '/testing/delete-testing-report',
    DOWNLOAD_TEST_LIBRARY: '/testing/download-testing-library',
  },
  PRODUCT_COSTING: {
    ADD_PRODUCT_COSTING: '/product-costing/add',
    GET_PRODUCT_COSTING_LIST: '/product-costing/list',
    DELETE_PRODUCT_COSTING: '/product-costing/delete',
    COMMON_API_PATH: '/product-costing',
    COPY_PRODUCT_COSTING: '/product-costing/copy',
    INVITE_SUPPLIER: '/product-costing/invite',
    CLEAR_ALL: '/product-costing/clear',
    ADD_COMMENT: '/product-costing/add-comment',
    GET_PRODUCT_COSTING_COMMENT_LIST: '/product-costing/comment/list',
    UPDATE_COSTING_COMMENT: '/product-costing/comment-update',
    FETCH_PRODUCT_COLOURS: '/order/colourways',
    FETCH_PRODUCT_LENGTHS: '/order/legLengths',
    FETCH_PRODUCT_SIZES: '/order/sizes',
    FETCH_UNINTERGRATED_PRODUCT_COSTING_DETAILS: '/product-costing-supplier',
    FETCH_UNINTERGRATED_COLOURWAYS: '/product-costing-colorways',
    FETCH_UNINTERGRATED_UNITS: '/product-costing-units',
    UPDATE_PRODUCT_COSTING: '/product-costing/update',
    SUPPLIER_DETAILS: '/product-costing/supplier-details',
    FETCH_EXCHANGE_RATE: '/costing-template/rate',
    SUPPLIER_CURRENCY_UPDATE: '/product-costing/supplier-currency',
    SET_PERMISSION: '/orders/permisson/product-costing',
    SET_DEFAULT: '/product-costing/set-default',
    POST_PERMISSION: developmentOrdersMarkCompletePath,
    FETCH_UNINTERGRATED_COSTING_STAGE: '/product-costing-stage',
    ADD_MULTI_COMMENT: '/product-costing/add-multi-comment',
    COSTING_STATS: '/product-costing/costing-stats',
    FETCH_SAMPLE_REFS: '/product-costing-sample-refs',
  },
  PRODUCT_ATTRIBUTES: {
    GET_ALL_USAGE_PRODUCTS: '/product-bom-linkage',
    GET_ALL_FACTORY_SUPPLIERS: '/factory-suppliers',
    DOWNLOAD_BOM_USAGE: '/download-bom-usage-xlsx',
    BULK_UPDATE_PRODUCT_BOM_COSTING: '/bulk-update-product-bom-costing',
  },
  TODO_LIST: {
    GET_TODO_LIST: '/dashboard/todo-list',
    TODO_LIST_EXPORT_EXCEL: '/dashboard/todo-list-export',
    GET_TODO_LIST_COUNT: '/dashboard/todo-list-count',
    REMOVE_SUBMIT_TODO_FROM_LIST: '/dashboard/remove-submit-todo-list',
    ADD_COMMENT_MULTIPLE_COSTING: '/dashboard/add-multicosting-comment',
    COSTING_STATS: '/dashboard/costing-stats',
    UPDATE_COSTING_TODO: '/costing-todo/costings',
    CALCULATE_COSTING_TODO: '/costing-todo/costings/calculate',
  },
  MY_TODO: {
    GET_MY_TODO_LIST: '/dashboard/my-todo',
    POST_MY_TODO_LIST: '/dashboard/my-todo/list',
    CREATE_MY_TODO: '/dashboard/my-todo',
    UPDATE_MY_TODO_STATUS: '/dashboard/my-todo/status',
    GET_MY_TODO_COUNT: '/dashboard/my-todo/count',
    DELETE_MY_TODO: '/dashboard/my-todo',
  },
  PLACEHOLDER: {
    SAVE_PLACEHOLDER: '/placeholder-management/add',
    SAVE_PRODUCT_PLACEHOLDER: '/placeholder-management/dev-order/update',
    GET_PLACEHOLDER: '/placeholder-management/list',
    DELETE_PLACEHOLDER: '/placeholder-management/delete',
    UPDATE_QTY: '/placeholder-management/update',
    GET_PRODUCT: '/placeholder-management/dev-order',
    SAVE_DRAFT: '/placeholder-management/draft',
    PUBLISH_DRAFT: '/placeholder-management/publish',
    FETCH_SEARCHED_PRODUCT: '/placeholder-management/searched-product',
    REPLACE_PLACEHOLDER: '/placeholder-management/replaced',
    ADD_PLACEHOLDER_CARD: '/placeholder-card-management/add-update',
    GET_INDIVIDUAL_DETAILS: '/placeholder-card-management/get',
    GET_PLACEHOLDER_CARD: '/placeholder-card-management/list',
    DELETE_PLACEHOLDER_CARD: '/placeholder-card-management/delete',
    ARCHIVE_PLACEHOLDER_CARD: '/placeholder-card-management/archive',
  },
  PLANNING_ACTUAL: {
    GET_FILTERED_DATA: '/planning-actual/filtered-category',
    AUTOSAVE: '/planning-actual/add',
    GET_YEAR_DATA: '/planning-actual/filter-compare-dates',
  },
  RANGEPLAN_PRODUCT_LIST: {
    GET: '/product-range-plan/product-info',
    BOM_GET: '/product-range-plan/product-info/BOM',
    MEASUREMENT_GET: '/product-range-plan/product-info/Measurement',
    ADD_PRODUCTINFO_DATA: '/product-range-plan/product-rangeplan',
    GET_EXPANDALL: '/product-range-plan/expand-list',
    EXCEL_SHEET: '/product-range-plan/excel-sheet',
    EXCEL_SHEET_DATA: '/product-range-plan/upload-excel-data',
    UPDATE_SUPPLIER_FACTORY: '/product-range-plan/update-factory',
    MULTIPLE_PRODUCT_COSTING: '/product-range-plan/get-multiple-product-costing',
    BULK_UPDATE_EXCHAGNE_RATE: '/product-range-plan/bulk-update-exchange-rate',
    GET_PRODUCT_GROUP: '/product-groups',
    AUTOSAVE: '/critical-path/autosave',
    UPDATE_PRODUCT_COSTING_LANDED_INFO: '/range-plan/produts-costing/landed-info/update',
    REFRESH_PRODUCT_COSTING: '/cron/product-costing',
    DOWNLOAD_RP_SHEETS: '/product-range-plan/export-sheets',
    UPLOAD_FILE: '/product-range-plan/upload-excel-sheet',
    GET_PRODUCT_INFORMATION: '/product-range-plan/rp-info',
    GET_RANGEPLAN_LOGS: '/range-plan/range-plan-logs',
    UPLOAD_RP_FILE: '/product-range-plan/upload-RP-excel-data',
    RP_CUSTOM_PRESIGNED_URL: '/product-range-plan/rp-custom-presigned-url',
    RANGE_PLAN_CARDS: {
      GET_RANGE_PLAN_CARDS: '/product-range-plan/get-range-plan-cards',
      CREATE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/create',
      UPDATE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/update',
      DELETE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/delete',
      DUPLICATE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/duplicate',
      ARCHIVE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/archive',
      UNARCHIVE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/unarchive',
      PIN_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/pin',
      ACTIVE_INACTIVE_RANGE_PLAN_CARD: '/product-range-plan/range-plan-card/active-inactive',
      GET_RANGE_PLAN_CARD_DETAIL: '/product-range-plan/range-plan-card/detail',
      CLEAR_RANGE_PLAN_CARD_DETAIL: '/product-range-plan/range-plan-card/clear-detail',
      SET_RANGE_PLAN_CARD_LOADING: '/product-range-plan/range-plan-card/loading',
      SET_RANGE_PLAN_CARD_FILTER: '/product-range-plan/range-plan-card/filter',
      CLEAR_RANGE_PLAN_CARD_FILTER: '/product-range-plan/range-plan-card/clear-filter',
    },
    CONFIRM_UPLOAD: '/product-range-plan/confirm-upload',
    DOWNLOAD: '/product-range-plan/download',
    COSTING_EXPORT_ALL: '/product-range-plan/costing-export-all',
    COSTING_EXPORT_SELECTED: '/product-range-plan/costing-export-selected',
    COLUMN_TOTALS: '/product-range-plan/column-totals',
  },
  PURCHASE_ORDER: {
    SAVE_SHIPPED_DATE: '/save-shipped-date',
    FETCH_PURCHASE_ORDER: '/purchase-orders-list',
    DOWNLOAD_PO_DOCS: '/purchase-orders-export',
    FETCH_DEVORDER: '/dev-order',
    FETCH_SUPPLIER: orderSupplierPath,
    FETCH_POTEMPLATE: '/po-template-libraries',
    FETCH_PROFILE: '/company/profile',
    FETCH_PODETAILS: '/order-create-po',
    FETCH_CREATE_PO_PERMISSION: '/orders/permisson/createPo',
    ADD_PO: '/order-create-po',
    FETCH_TRADE_REF: '/orders/permisson/trade-ref',
    FETCH_MATERIAL_PLACEMENT: '/masters/material-Placement-component',
    FETCH_LEG_LENGTHS: '/masters/leg-lengths',
    FETCH_SIZES: '/masters/sizes',
    FETCH_DOCUMENTS: '/po-documents',
    POST_DOCUMENTS: '/po-file/upload',
    SHIPMENT_DATES: '/ship-dates',
    SAVE_SHIPMENT_DATES: '/save-shipped-date',
    FETCH_PO_HISTORY: '/po-history',
    APPROVE_REJECT_STATUS: '/order-po-status',
    MARK_COMPLETE: developmentOrdersMarkCompletePath,
    HISTORY_PREVIEW: '/po-preview-history',
    PUBLIC_PO: '/purchase-order-open',
    PUBLIC_PURCHASE_PO: '/purchase-order/poId',
    SAVE_PO_DOCUMENT: '/component-order/purchase-order/upload-file',
    FETCH_UPLOADED_DOCUMENT: '/component-order/purchase-order/upload-po-document',
    EDIT_PURCHASE_ORDER_DOCUMENT: '/component-order/purchase-order/edit-po-document',
    DELETE_PURCHASE_ORDER_DOCUMENT: '/component-order/purchase-order/delete-po-document',
  },
  CUSTOM_SECTION_TEMPLATE: {
    COMMON_PATH: '/rangeplan-custom-section/sections',
    COLUMN_NAME_CHANGE: '/rangeplan-custom-section/name',
    COLUMN: '/rangeplan-custom-section/column',
    BULK_DELETE_COLUMNS: '/rangeplan-custom-section/bulk-delete-columns',
    APPLY_DEFAULT_OPTIONS: '/rangeplan-custom-section/apply-default-options',
    CUSTOM_SECTION: '/product-range-plan/product-rangeplan/customSection',
    FETCH_ALL_SECTIONS_COLUMNS: '/rangeplan-custom-section/allSections',
    FETCH_ALL_SELECTED_RP_SECTIONS: '/rangeplan-custom-section/rp-custom-sections',
    GET_SECTION_COLUMNS: '/product-range-plan/product-rangeplan/getAllSectionColumns',
    COMPANY_USERS: '/company/company-users',
    UPDATE_CUSTOMSECTION_SEQUENCE: '/rangeplan-custom-section/update-sequence',
    SET_DEFAULT_CUSTOMSECTION: '/rangeplan-custom-section/set-default',
    ADD_CUSTOMSECTION: '/rangeplan-custom-section/add',
    UPDATE_CUSTOMSECTION: '/rangeplan-custom-section/update',
  },
  PLANNING_BOTTOM: {
    GET_DATA: '/planning-bottom-up/list',
    SAVE_DATA: '/planning-bottom-up/add',
    GET_YEAR_DATA: '/planning-actual/filter-compare-dates',
    ADD_CHANNEL: '/planning-bottom-channel/add',
    GET_CHANNEL: '/planning-bottom-channel/list',
    EDIT_CHANNEL: '/planning-bottom-channel/edit',
    SET_SEQUENCE: '/planning-bottom-channel/update-sequence',
    DELETE_CHANNEL: '/planning-bottom-channel/delete',
  },
  PO_TEMPLATE: {
    FETCH_TABLE_DATA: '/po-template-libraries',
    FETCH_PO_LIST: '/component-order/po-template',
    DUPLICATE_PO_TEMPLATE: '/component-order/po-template/duplicate',
  },
  COMPONENT_PURCHASE_ORDER: {
    FETCH_PURCHASE_ORDER: '/component-order/purchase-order',
    FETCH_SUPPLIER_PURCHASE_ORDER: '/component-order/component-po',
    DOWNLOAD_PURCHASE_ORDER: '/component-order/component-po-download',
    DUPLICATE_PURCHASE_ORDER: '/component-order/duplicate-purchase-order',
    SENT_EMAIL_TO_SUPPLIER: '/component-order/component-po-send',
    APPROVE_REJECT_PO: '/component-order/component-po/status',
    FETCH_PURCHASE_ORDER_LIST: '/component-order/purchase-order-list',
    LOCAL_FILE_SERVE: '/component-order/get/docx',
  },
  OPRATIONAL_CP: {
    GET_OPERATIONAL_CP: '/operational-cp/list',
    GET_INDIVIDUAL_OPERATIONAL_CP: '/operational-cp',
    ADD_UPDATE_CP: '/operational-cp/add-update',
    ADD_ROWS_IN_CP: '/operational-cp/rows',
    DELETE_OPRATIONAL_CP: '/operational-cp/delete',
    DELETE_OPRATIONAL_CP_ROWS: '/operational-cp/delete-rows',
    ADD_UPDATE_COLUMNS_IN_CP: '/operational-cp/columns',
    DELETE_OPRATIONAL_CP_COLUMNS: '/operational-cp/delete-columns',
    GET_DYNAMIC_ROW_COLUMN_DETAILS: '/operational-cp/details',
    SAVE_MANUAL_DETAILS: '/operational-cp/manual-details',
    LAST_OPENED: '/operational-cp/last-opened',
    DUPLICATE_OPERATIONAL_CP: '/operational-cp/duplicate-ocp',
    OCP_EXCEL_SHEET_DOWNLOAD: '/operational-cp/ocp-excel-sheet',
  },
  PRODUCT_CP: {
    ADD_UPDATE_CP: '/product-cp/add-update',
    GET_PRODUCT_CP: '/product-cp/list',
    GET_INDIVIDUAL_DETAILS: '/product-cp',
    DELETE_PRODUCT_CP: '/product-cp/delete-archive',
    DUPLICATE_PRODUCT_CP: '/product-cp/duplicate-pcp',
    ADD_UPDATE_PRODUCTCP_TABS: '/product-cp/tabs/add-update',
    GET_PRODUCTCP_TABS: '/product-cp/all-tabs',
    ADD_UPDATE_COLUMNS_IN_PCP: '/product-cp/columns',
    DELETE_PRODUCT_CP_COLUMNS: '/product-cp/delete-columns',
    ACTIVE_INACTIVE_COLUMNS: '/product-cp/active-inactive-columns',
    GET_DYNAMIC_COLUMN_DETAILS: '/product-cp/details',
    SOURCE_COLUMN_STATS: '/product-cp/source-column-stats',
    SAVE_MANUAL_DETAILS: '/product-cp/manual-details',
    SAVE_MANUAL_DETAILS_PO: '/product-cp/manual-details-po',
    REARRANGE_PRODUCT_CP_TABS: '/product-cp/tabs/rearrange',
    DELETE_PRODUCTCP_TABS: '/product-cp/tabs/delete',
    GET_VERIFIED_SUPPLIERS: '/product-cp/assignee-list',
    PCP_EXCEL_SHEET_DOWNLOAD: '/product-cp/pcp-excel-sheet',
    GET_PRODUCTCP_LOGS: '/product-cp/logs',
    BULK_UPDATE: '/product-cp/bulk-update',
    PIN_UNPIN_COLUMN: '/product-cp/pin-unpin-tab-column',
    COLUMN_OPTIONS: '/product-cp/columns-options',
    UPDATE_DETAIL_BY_SUPPLIER: '/product-cp/detail-update',
    PCP_PRESIGNED_URL: '/product-cp/pcp-presigned-url',
    PCP_PRESIGNED_URL_PRODUCT: '/product-cp/pcp-presigned-url-product',
  },
  PRODUCT_HISTORY: {
    GET_LIST: '/order-history',
    GENERATE_CHANGES: '/product-history',
  },
  MULTI_SUBMIT_BATCH: {
    PRODUCT_DETAILS: '/development-orders/batch/product-details',
    CORE_PRODUCT_DETAILS: '/development-orders/batch/core-product-details',
    BOM_DOCUMENTS: '/order-supporting/BOM/documents/batch',
    MEASUREMENT_DOCUMENTS: '/order-measurements/documents/batch',
    PO_DOCUMENTS: '/order-create-po/documents/batch',
    DESIGN_DOCUMENTS: '/design-details-supporting-doc/batch',
    SAMPLES: '/orders-samples/batch',
    PRODUCT_SAMPLES: '/orders-samples/product-batch',
    SAMPLE_TYPE_GROUPS: '/sample-type-groups/batch',
  },
  SUBMIT_DOWNLOAD: {
    GET_PO_BY_DEVORDER_SUPPLIER: '/purchase-orders',
    GET_FILTERED_POS: '/product-purchase-orders/filtered',
    ORDER_SUBMIT_DOWNLOAD: '/order-submit-download',
    SUBMIT_DOWNLOAD_REQUESTS: '/submit-download-requests',
    REQUEST_SAMPLE_MULTI_PRODUCTS: '/request-sample-multi-products',
    GET_PO_DOCUMENTS: '/order-create-po/documents',
    GET_BOM_SUPPORTING_DOCUMENTS: '/order-supporting/BOM/documents',
    SEND_SUPPLIER_EMAIL: '/order-supplier-pdf',
    ORDER_DOWNLOAD_LOG: '/order-download-log',
    ACTIVE_INACTIVE_SUBMIT_LOG: '/download-files/activate-log',
    DOWNLOAD_FILES: '/order-files/download',
    DOWNLOAD_FILES_URL_MAIN: '/download-files',
    DOWNLOAD_LOG: '/download/log',
    SUPPLIER_USER: '/order/supplierUsers',
    MULTI_SUBMIT_DOWNLOAD_LOGS: '/multi-submit-download-logs',
    MULTI_DOWNLOAD_LOGS: '/multi-download-logs',
    DOWNLOAD_BY_UPDATE: '/download-by-update',
  },
  PIM_V2: {
    CHANNELS: '/pim/channels',
    CHANNELS_V2: '/pim-v2/channels',
    CHANNELS_ARCHIVED: '/pim/channels/archived',
    CHANNEL_UPLOAD_IMAGE: '/pim/channels/upload-image',
    CHANNEL_SETUPS: '/pim/channel-setups',
    TABS: '/pim/tabs',
    TABS_REORDER: '/pim/tabs/reorder',
    SUB_TABS: '/pim/sub-tabs',
    SUB_TABS_REORDER: '/pim/sub-tabs/reorder',
    SUB_TABS_BULK_CREATE: '/pim/sub-tabs/bulk-create',
    SUB_TABS_WITH_COLUMNS: '/pim-v2/sub-tabs/with-columns',
    COLUMNS: '/pim/columns',
    COLUMNS_LOOKUP: '/pim/columns/lookup',
    COLUMNS_REORDER: '/pim/columns/reorder',
    COLUMNS_REQUIRED: '/pim/columns/required',
    COLUMN_MAPPING_REGISTRY: '/pim/column-mapping-registry',
    ROWS: '/pim/rows',
    ROWS_PUBLISH: '/pim/rows/publish',
    ROWS_PUBLISH_PRODUCT: '/pim/rows/publish-product',
    ROWS_EXPORT: '/pim/rows/export',
    ROWS_PRODUCTS: '/pim/rows/products',
    ROWS_IDS: '/pim/rows/ids',
    ROWS_VARIANTS: '/pim/rows/variants',
    ROWS_BULK_ACTION: '/pim/rows/bulk-action',
    ROWS_IMPORT: '/pim/rows/import',
    ROWS_BULK_UPDATE: '/pim/rows/bulk-update',
    ROW_IMAGE: '/pim/rows/:rowId/images/:imageType',
    ROW_IMAGE_STATUS: '/pim/rows/:rowId/images/:imageType/status',
    ACCORDION_SECTIONS: '/pim/accordion-sections',
    DOWNLOADS: '/pim/downloads',
    DEV_ORDERS_SEARCH: '/pim/dev-orders/search',
    HISTORY: '/pim/history',
    USER_COLUMN_PREFERENCES: '/pim/user-column-preferences',
    USER_COLUMN_PREFS: '/pim-v2/user-column-preferences',
    META_LIMITS: '/pim-v2/meta/limits',
    CHANNEL_SETUP_UPLOAD_TEMPLATE: '/pim-v2/channel-setups/:setupId/upload-template',
    CHANNEL_SETUP_COMPLETE_MAPPING: '/pim-v2/channel-setups/:setupId/complete-mapping',
    CHANNEL_SETUP_UNDO_TEMPLATE: '/pim-v2/channel-setups/:setupId/template',
    CHANNELS_BULK_ARCHIVE: '/pim-v2/channels/bulk-archive',
    CHANNELS_BULK_UNARCHIVE: '/pim-v2/channels/bulk-unarchive',
    CHANNELS_BULK_DELETE: '/pim-v2/channels/bulk-delete',
    CHANNEL_COLUMNS: '/pim/channels/:channelId/columns',
    CHAT_ACCESSIBLE_SETUPS: '/pim-v2/chat/accessible-setups',
    CHAT_UNREAD_COUNTS: '/pim-v2/chat/unread-counts',
    CHAT_MESSAGES: '/pim-v2/chat/:channelSetupId/messages',
    CHAT_MARK_READ: '/pim-v2/chat/:channelSetupId/mark-read',
    CHAT_MESSAGE: '/pim-v2/chat/:channelSetupId/messages/:serial',
  },
  // Track A (Step 3 / BM-9115): auto-import + manual-search-add + soft-remove.
  // Paths are stubbed against the backend agent's draft contract; confirm and
  // adjust once the server controller lands.
  PIM_V2_AUTO_IMPORT: {
    SEARCHABLE_PRODUCTS: '/pim-v2/auto-import/searchable-products',
    MANUAL_SEARCH_ADD: '/pim-v2/auto-import/manual-search',
    SOFT_REMOVE_ROW: '/pim-v2/pim-rows/:rowId/soft-remove',
    CHECK_BY_DEV_ORDERS: '/pim-v2/pim-rows/check-by-dev-orders',
    DELETE_ROWS_BY_DEV_ORDER: '/pim-v2/pim-rows/by-dev-order',
  },
  FRIGHT_DUTY_LIBRARY: {
    FREIGHT_ADD_UPDATE: '/v1/freight/add-update',
    FREIGHT_LIST: '/v1/freight/list',
    DUTY_LIST_V1: '/v1/duty/list',
    DUTY_ADD_UPDATE_V1: '/v1/duty/add-update',
    DUTY_DELETE_V1: '/v1/duty/delete',
    FREIGHT_DELETE: '/v1/freight/delete',
    FREIGHT_DUPLICATE: '/v1/freight/duplicate',
    FREIGHT_EXCEL_UPLOAD: '/v1/freight/excel/upload',
    DUTY_EXCEL_UPLOAD: '/v1/duty/excel/upload',
    DOWNLOAD_DUTY_EXCEL: '/v1/duty/download-duty-xlsx',
    IMPORT_DUTY_EXCEL: '/v1/duty/import-duty-xls',
    DOWNLOAD_FRIGHT_EXCEL: '/v1/freight/download-freight-xlsx',
    IMPORT_FREIGHT_EXCEL: '/v1/freight/import-freight-xls',
  },
  CARE_LABEL: {
    CARE_LABEL_COMMON: '/care-libraries',
    IMPORT_LIBRARY: gradingsImportXlsPath,
    CARE_LABEL_GROUP: '/care-groups',
    DOWNLOAD_CARE_LABEL: '/download-care-xlsx',
    UPLOAD_FILE: '/import-care-xls',
  },
  CARE_LABEL_PRODUCT: {
    GET_CARE_LABEL: '/care-label',
    GET_CARE_LABEL_GROUP: '/order-Care-groups',
    GET_CARE_LABEL_PRODUCT: orderPreviousStylesPath,
    GET_CARE_LABEL_PRODUCT_LIST: '/order/care',
    GET_CARE_LABEL_PRODUCT_DATA: '/care-label/previous-style',
    GET_CARE_LABEL_LAYOUT_DATA: '/orders/reports/care-label',
    APPROVE_REJECT_PDF: '/care-label-approval',
    SEQUENCE: '/sequence',
    GET_PRODUCT_CARE_INSTRUCTION: '/care-instruction',
    REARRANGE_CARE_LABEL: '/save-sequence',
    GET_PRODUCT_CARE_GROUP: '/care-instruction-group',
    GET_PRODUCT_LIST: '/care-label-products',
    GET_CARE_LIBRARIES: '/care-instruction-libraries',
    GET_PRODUCT_CARE_DATA: '/care-products',
    GET_PRODUCT_CARE_DATA_REFRESH: '/care-products-refresh',
    IMPORT_CARE_LABEL: '/care-instruction-import-care',
    IMPORT_CARE_GROUP: '/import-care-group',
    ADD_TO_LIBRARY: '/add-to-library',
  },
  CUSTOM_MODULE: {
    COMMON_CUSTOM_MODULE: '/custom-module-libraries',
    COMMON_CUSTOM_MODULE_GROUP: '/custom-module-groups',
    DUPLICATE_CUSTOM_MODULE: '/duplicate-custom-module',
    DOWNLOAD_CUSTOM_TABLE_SAMPLE: '/custom-module-table',
    COMMON_CUSTOM_MODULE_STATUS: '/custom-module-library/update-status',
    UPLOAD_CM_IMAGE: '/upload-cm-image-s3',
    GET_NEW_PAGEID: '/custom-module-new-page',
    DELETE_PAGE_ID: '/custom-module-delete-page',
    CUSTOM_MODULE_LIST: '/custom-module-page-list',
    CUSTOM_MODULE_PAGE_REARRANGE: '/custom-page-rearrange',
    CUSTOM_MODULE_CONTENT_PAGE: '/custom-module-content-page',
    CUSTOM_MODULE_PAGE_CONTROLS: '/get-page-controls',
    CUSTOM_MODULE_PAGES: '/custom-module-page-source-list',
    CUSTOM_MODULE_DEPENDENT_CONTROLS: '/get-dependent-page-controls',
    COMMON_CUSTOM_CONTENT_DATA: '/custom-module-content-page',
    CUSTOM_MODULE_PAGE_CALCULATION_CONTROLS: '/get-page-calculation-controls',
    PREVIEW_CUSTOM_MODULE: '/template-preview',
    COMMON_CUSTOM_MODULE_GROUP_STATUS: '/custom-module-group/update-status',
  },
  MEASUREMENT: {
    UPLOAD_DOCUMENT: '/order-measurements/upload',
    GET_DOCUMENT_LIST: '/order-measurements/documents',
    UPDATE_DOCUMENT: '/order-measurements/update',
    DELETE_DOCUMENT: '/order-measurements/delete',
    UPDATE_DOCUMENT_STATUS: '/order-measurements/update-status',
    GET_DEV_ORDER_GRADING_GROUPS: '/order-measurements/get-dev-order-grading-groups',
    UPDATE_DEV_ORDER_GRADING_GROUPS: '/update-dev-order-grading-groups',
    UPDATE_PRODUCT_IDENTIFIER: '/update-product-identifier',
    ADD_UPDATE_POMS_TO_GRADING: '/add-update-poms-to-grading',
    UPDATE_SAMPLE_SIZE_CHANGED: '/update-sample-size',
    GET_SAMPLE_SIZE_NAME: '/get-sample-size-name',
    UPDATE_HIDDEN_SIZES: '/update-hidden-sizes',
  },
  SPEC_TEMPLATE: {
    ALL_GRADING: '/gradings',
    GET_PUT_SPEC_DETAIL: '/spec-template-libraries',
    DUPLICATE_SPEC_LIBRARY: '/duplicate-spec-template',
    SPEC_TEMP_SUPPORTING_DOC: '/spec-template-supporting-doc',
    ALL_SPECT_TEMPLATE: '/all-spec-template-libraries',
    ADD_DOCUMENT_TO_LIBRARY: '/add-to-library-spec-doc',
    IMPORT_DOCUMENT_TO_SPEC: '/import-supporting-doc',
  },
  DAM: {
    FETCH_DAM_LIST: '/dam/list',
    FETCH_DAM_PRODUCT_LIST: '/dam/product-list',
    FETCH_DAM_TAGS_LIST: '/dam/tags-list',
    SAVE_DAM_FILES: '/dam/add',
    UPDATE_DAM_FILES: '/dam/update',
    DELETE_DAM_FILES: '/dam/delete',
    GET_DAM_BY_ID: '/dam/edit',
    ARCHIVE_DAM: '/dam/archive-unarchive',
    DUPICATE_DAM_FILE: '/dam/duplicate',
    FETCH_ARCHIVED_FILES: '/dam/archived/list',
    UPDATE_FOLDER_BY_ID: '/dam/update-file-in-folder',
    FETCH_DELETED_FILES: '/dam/deleted/list',
    REFRESH_PRODUCT_DAM: '/dam/refresh-product-dam',
    CHECK_ASSET_NAME_EXIST: '/dam/check-dam-exist',
  },
  S3_URLS: {
    WRITE_PRESIGNED_URL: '/getSignedUrl/write-presignedurl',
    READ_PRESIGNED_URL: '/getSignedUrl/read-presignedurl',
    DOWNLOAD_PRESIGNED_URL: '/getSignedUrl/download-presignedurl',
    PROXY_FILE: '/getSignedUrl/proxy-file',
    DELETE_OBJECTS_URL: '/getSignedUrl/delete-s3-objects',
    FETCH_VIMEO_META_DATA: '/getSignedUrl/vimeo-metadata',
    FETCH_YOUTUBE_META_DATA: '/getSignedUrl/youtube-metadata',
    FETCH_COMPRESSED_BUFFER: '/getSignedUrl/compressed-buffer',
    MULTIPART_CREATE: '/getSignedUrl/multipart/create',
    MULTIPART_SIGN_PARTS: '/getSignedUrl/multipart/sign-parts',
    MULTIPART_COMPLETE: '/getSignedUrl/multipart/complete',
    MULTIPART_ABORT: '/getSignedUrl/multipart/abort',
  },
  DAM_FOLDER_GROUP: {
    GET: '/dam-folder-group/list',
    CREATE: '/dam-folder-group/add',
    GET_BY_ID: '/dam-folder-group/get-edit-data/',
    UPDATE: '/dam-folder-group/update/',
    DELETE: '/dam-folder-group/delete/',
    ACTIVE_INACTIVE_DAM: '/dam-folder-group/active-inactive',
    FILTER_SEARCH_FILES: '/dam/filer-seached-files',
    DELETE_FOLDER_IMAGE: '/dam-folder-group/delete/s3-image',
    DELETE_FOLDER_FILE: '/dam-folder-group/delete/open-files',
    DUPICATE_DAM_FOLDER: '/dam-folder-group/duplicate',
    ARCHIVE_UNARCHIVE_DAM_FOLDER: '/dam-folder-group/archive-unarchive',
    FETCH_ARCHIVED_FOLDER: '/dam-folder-group/archived/list',
    FETCH_DELETED_FOLDER: '/dam-folder-group/deleted/list',
    DAM_FOLDER_ALL_LIST: '/dam-folder-group/all-folder-list',
  },
  DAM_HISTORY: {
    GET_DAM_HISTORY_LIST: '/dam-history',
  },
  DAM_PRODUCT_FILE: {
    FETCH_DAM_FILE_LIST: '/product-dam/list',
    DELETE_PRODUCT_DAM_FILES: '/product-dam/delete',
    UPDATE_PRODUCT_FILES_TO_LIBRARY: '/product-dam/add-to-library',
    ADD_PRODUCT_FILE: '/product-dam/add',
    GET_PRODUCT_DAM_BY_ID: '/product-dam/edit',
    UPDATE_PRODUCT_DAM_FILES: '/product-dam/update',
    FETCH_DAM_PRODUCT_TAGS_LIST: '/product-dam/tags-list',
    FETCH_PRODUCT_FOLDER_OPTION_LIST: '/product-dam/product-folderlist',
    CHECK_DAM_NAME_EXIST: '/product-dam/check-productdam-exist',
  },
  DAM_PRODUCT_FOLDER: {
    UNLINK: '/product-dam/unlink',
    FETCH_DAM_FOLDER_LIST: '/product-dam/product-folder',
  },
  DPP: {
    DPP_ADD_LIBRARY: '/library-dpp/add-dpp',
    GET_DPP_BY_ID: '/library-dpp/fetch-dpp-record',
    GET_DPP_LIST: '/library-dpp/get-dpp-list',
    UPDATE_DPP_BY_ID: '/library-dpp/update-dpp',
    UPLOAD_DPP_IMAGE: '/library-dpp/upload-dpp-image-s3',
    FETCH_META_DATA: '/library-dpp/fetch-metadata',
    DELETE_DPP_LIBRARY: '/library-dpp/delete-dpp',
    GET_PRODUCT_DPP_BY_ID: '/product-dpp/dpp-details/',
    ADD_PRODUCT_DPP: '/product-dpp/update-dpp/',
    UPLOAD_IMAGE_TO_S3: '/product-dpp/product-upload-dpp-image-s3',
    REFRESH_DPP_CONTROL: '/product-dpp/refresh-dpp-control',
    REFRESH_CONTROL_PLUS_VALUE: '/product-dpp/refresh-control-plus-value',
  },
  SUPPLIER_TO_DO: {
    SAVE_CONFIG_DATA: '/dashboard/add-supplier-to-do-config',
    GET_CONFIG_DATA: '/dashboard/get-supplier-to-do-config',
    GET_SUPPLIER_DETAIL_DATA: '/dashboard/supplier-to-do',
    GET_COMPONENT_SUB_TYPE: '/masters/all-component-sub-type',
  },
  USERINSTRUCTIONS: {
    GET: '/user-instructions',
    GET_USER_DETAILS_DATA: '/user-instructions-columns',
    GET_TABS: '/user-instructions-details',
    DOWNLOAD_CARE_LABEL: '/download-care-user-xlsx',
    UPLOAD_FILE: '/import-care-user-xls',
    GET_CARE_USER_GROUP: '/care-user-instruction-groups',
    CHECK_UNIQUE_PRODUCT_TYPE: '/check-unique-product-type',
    GET_CARE_LIBRARIES: '/get-care-libraries',
    GET_ALL_COLUMNS: '/get-all-columns',
    REFRESH_TABS: '/refresh-tabs',
  },
  GOOGLE_MAP_API: {
    FETCH_MAP_LAT_LAG: '/getSignedUrl/google-map',
    GOOGLE_MAP_PLACES_AUTOCOMPLETE: '/getSignedUrl/google-map-place-autocomplete',
    GOOGLE_MAP_PLACES_DETAILS: '/getSignedUrl/google-map-places-details',
    GOOGLE_MAP_PLACES_NEARBY: '/getSignedUrl/google-map-places-nearby',
  },

  ABLY: {
    REQUEST_TOKEN: '/ably/request-token',
  },

  CHAT: {
    SAVE_MESSAGE: '/chat',
    GET_MESSAGES: '/chat/messages',
    MARK_READ: '/chat/mark-as-read',
    UNREAD_COUNT: '/chat/unread-count',
    DELETE_MESSAGE: '/chat',
    EDIT_MESSAGE: '/chat',
    GET_PARTICIPANTS: '/chat/get-participants',
    USERS_LIST: '/chat/users-list',
    GET_UNREAD_MESSAGES: '/chat/get-unread-messages',
  },

  MANUAL_DOCUMENTS: {
    SAVE_DOCUMENT: '/manual-documents/document/add',
    GET_DOCUMENT_LIST: '/manual-documents/document/list',
    DELETE_DOCUMENT: '/manual-documents/document/delete',
    BREAD_CRUMB_DATA: '/manual-documents/document/breadCrumb',
    ARCHIEVE_UNARCHIEVE_DATA: '/manual-documents/document/archive-unarchived',
    GET_FILE_BY_ID: '/manual-documents/documents-file',
    RENEW_DOCUMENT: '/manual-documents/document/renew',
    GET_ALL_FOLDER_DOCUMENT: '/manual-documents/document/folder/list',
    MOVE_DOCUMENT: '/manual-documents/document/drop/move',
    SHARE_DOCUMENT: '/manual-documents/document/share',
    EDIT_DOCUMENT: '/manual-documents/edit-document-file',
    DOWNLOAD_FOLDER: '/manual-documents/document/download/folder',
  },
  SYSTEM_CANVAS: {
    CONTROL_TYPES: '/system-canvas/controls',
    CONTROL_TYPE_BY_ID: '/system-canvas/controls/',
    MODULES: '/system-canvas/modules',
    MODULE_BY_ID: '/system-canvas/modules/',
    MODULE_DETAILS: '/system-canvas/modules/',
    GET_TAB_DETAILS: '/system-canvas/modules/',
    DUPLICATE_CONTROL: '/system-canvas/controls/',
    DUPLICATE_MODULE: '/system-canvas/modules/',
    CONTROLS: '/system-canvas/controls',
    MODULE_ICON: '/system-canvas/modules/',
  },
  DEVELOPMENT_ORDERS_MODULES: {
    CREATE_OR_UPDATE: '/development-orders-modules',
    PARTIAL_UPDATE: '/development-orders-modules',
    GET_AVAILABLE_MODULES: '/development-orders/',
    GET_MODULE_DATA_WITH_SOURCE: '/development-orders/',
    GET_TAB_DETAILS: '/development-orders/',
  },
  PURCHASE_ORDER_TEMPLATE: {
    GENERAL: '/purchase-order-template',
  },
  PRODUCT_PURCHASE_ORDER: {
    GET_PRODUCT_DETAILS: '/po-product-details',
    GET_COMPANY_DETAILS: '/po-company-details',
    GENERAL_PRODUCT_PO: '/product-purchase-orders',
    SEARCH_PRODUCT_PO: '/product-purchase-orders/search',
    FILTER_DEVELOPMENT_ORDERS: '/po-product-details/development-orders',
    CREATE_ORDER_FILE: '/product-purchase-orders-file',
    GET_ORDER_FILES_LIST: '/product-purchase-orders',
    GET_ORDER_FILE_DETAILS: '/product-purchase-orders-file/details',
    UPDATE_ORDER_FILE: '/product-purchase-orders-file/details',
    DELETE_ORDER_FILE: '/product-purchase-orders-file/details',
    BULK_DELETE_ORDER_FILES: '/product-purchase-orders-file/bulk-delete',
    FETCH_OLD_PO_PREVIEW: '/order-create-po',
    BULK_DELETE_OLD_PO: '/order-create-po/bulk-delete',
    PURCHASE_ORDERS_LIST: '/purchase-orders-list',
    DOWNLOAD_PDF: '/product-purchase-orders/download-pdf',
    EXPORT_SAMPLE: '/product-purchase-orders/export-sample',
    UPDATE_STATUS: '/product-purchase-orders',
    GET_LOGS_AND_HISTORY: '/product-purchase-orders-logs',
    GET_LOG_BY_ID: '/product-purchase-orders/logs',
    GET_LOG_DETAILS_BY_ID: '/product-purchase-orders/logs-detailed',
    BULK_FILTERED: '/product-purchase-orders/bulk-filtered',
    BULK_DELETE: '/product-purchase-orders/bulk-delete',
    SET_DEFAULT: '/product-purchase-orders/set-default',
    TEMPLATES: '/product-purchase-orders/templates',
    EXPORT: '/product-purchase-orders/export',
    DUPLICATE: '/product-purchase-orders/duplicate',
    HISTORY: '/product-purchase-orders/history',
    GET_SUPPLIER_FACTORIES: '/factory/list',
  },
  PRODUCT_PURCHASE_ORDER_TODO: {
    FETCH_LIST: '/product-purchase-order-todo/list',
    COUNT: '/product-purchase-order-todo/count',
    UPDATE_ACTUAL_FIELDS: '/product-purchase-order-todo/update-actual-fields',
    DELETE: '/product-purchase-order-todo/delete',
    BULK_DELETE: '/product-purchase-order-todo/bulk-delete',
    EXPORT_SELECTED: '/product-purchase-order-todo/export-selected',
    EXPORT_ALL: '/product-purchase-order-todo/export-all',
    PRESIGNED_UPLOAD: '/product-purchase-order-todo/presigned-upload',
    MOVE_ERROR_SHEET_TO_UPDATE: '/product-purchase-order-todo/move-error-sheet-to-update',
  },
  COMPANY: {
    MAIN_SUPPLIERS: '/api/company/main-suppliers',
  },
  SAMPLE_ORDERS: {
    GRADING_GROUP_POMS: '/sample-orders/grading-group-poms',
    IMPORT_POM_TO_SPEC: '/sample-orders/import-pom-to-spec',
    ADD_MANUAL_POM_TO_SPEC: '/sample-orders/add-manual-pom-to-spec',
    DELETE_POM_FROM_SPEC: '/sample-orders/delete-pom-from-spec',
    REORDER_POM_SEQUENCE: '/sample-orders/reorder-pom-sequence',
  },
  SUPPORTING_DOCUMENT_TODO: {
    GET: '/dashboard/supporting-document-todo',
    EXPORT_ALL: '/supporting-document-todo/export-all',
    EXPORT_SELECTED: '/supporting-document-todo/export-selected',
    BULK_DELETE: '/supporting-document-todo/bulk-delete',
},
  RETAIL_IDENTIFIER: {
    BARCODE_TYPES: '/retail-identifier/barcode-types',
    PARSE_BARCODES: '/retail-identifier/barcodes/parse',
    LIST_BATCHES: '/retail-identifier/batches',
    CREATE_BATCH: '/retail-identifier/batches',
    UPDATE_BATCH: '/retail-identifier/batches/',
    ARCHIVE_BATCHES: '/retail-identifier/batches',
    UPLOAD_BATCH: '/retail-identifier/batches/',
    LIST_BARCODES: '/retail-identifier/',
    DOWNLOAD_BARCODES: '/retail-identifier/',
    /**
     * Where a barcode's assignments are read from. The claim itself has no endpoint of
     * its own — it happens as part of saving a product's identifiers, so the pull button
     * calls the product-identifier resource instead (BM-9855).
     */
    LIST_ASSIGNMENTS: '/retail-identifier/assignments',
  },
  PRODUCT_DIMENSION: {
    BY_DEV_ORDER: '/v1/dev-orders/:devOrderId/dimensions',
  },
  AUTOMATED_FREIGHT: {
    BY_DEV_ORDER: '/v1/dev-orders/:devOrderId/automated-freight',
  },
  RANGE_PLAN_IDENTIFIER_BARCODES: {
    RETAIL: '/v1/range-plan/product-identifiers/retail-barcodes',
    GTIN14: '/v1/range-plan/product-identifiers/gtin14-barcodes',
  },
};
export default API;
